import angular from 'angular';

export default angular.module('cloudModule', [
    'core.ui',
    'ui.router',
    'cloudService'
]);



// WEBPACK FOOTER //
// ./modules/cloud/cloud.module.js